import React from "react";

export default function MoreBtn({
  more_actions,
  title = "More",
  className = "mt20",
}) {
  return (
    <div className={`dropdown ${className}`}>
      <a
        className="btn btn-green btn-outline dropdown-toggle width-120"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
      >
        <span className="pr10">{title}</span>
        <span className="caret"></span>
      </a>
      <ul className="dropdown-menu">
        {more_actions.map((value, index) => {
          return (
            <li key={index}>
              <a href={value.url} className="dropdown-item" target="_blank">
                {value.title}
              </a>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
